var map = {
	"./Left/10000Hz/D1.wav": 3084,
	"./Left/10000Hz/D2.wav": 9427,
	"./Left/10000Hz/D3.wav": 5418,
	"./Left/10000Hz/D4.wav": 3153,
	"./Left/10000Hz/Target.wav": 7830,
	"./Left/1000Hz/D1.wav": 8132,
	"./Left/1000Hz/D2.wav": 7419,
	"./Left/1000Hz/D3.wav": 9506,
	"./Left/1000Hz/D4.wav": 2441,
	"./Left/1000Hz/Target.wav": 7230,
	"./Left/2000Hz/D1.wav": 7231,
	"./Left/2000Hz/D2.wav": 2472,
	"./Left/2000Hz/D3.wav": 1089,
	"./Left/2000Hz/D4.wav": 4122,
	"./Left/2000Hz/Target.wav": 7529,
	"./Left/250Hz/D1.wav": 568,
	"./Left/250Hz/D2.wav": 8639,
	"./Left/250Hz/D3.wav": 6678,
	"./Left/250Hz/D4.wav": 3749,
	"./Left/250Hz/Target.wav": 4106,
	"./Left/3000Hz/D1.wav": 3994,
	"./Left/3000Hz/D2.wav": 3205,
	"./Left/3000Hz/D3.wav": 8364,
	"./Left/3000Hz/D4.wav": 4447,
	"./Left/3000Hz/Target.wav": 8868,
	"./Left/4000Hz/D1.wav": 1021,
	"./Left/4000Hz/D2.wav": 1362,
	"./Left/4000Hz/D3.wav": 3099,
	"./Left/4000Hz/D4.wav": 2800,
	"./Left/4000Hz/Target.wav": 3599,
	"./Left/5000Hz/D1.wav": 8136,
	"./Left/5000Hz/D2.wav": 1311,
	"./Left/5000Hz/D3.wav": 6342,
	"./Left/5000Hz/D4.wav": 9157,
	"./Left/5000Hz/Target.wav": 1978,
	"./Left/500Hz/D1.wav": 9224,
	"./Left/500Hz/D2.wav": 7295,
	"./Left/500Hz/D3.wav": 5334,
	"./Left/500Hz/D4.wav": 2405,
	"./Left/500Hz/Target.wav": 1866,
	"./Left/6000Hz/D1.wav": 5891,
	"./Left/6000Hz/D2.wav": 9276,
	"./Left/6000Hz/D3.wav": 469,
	"./Left/6000Hz/D4.wav": 3398,
	"./Left/6000Hz/Target.wav": 2869,
	"./Left/7000Hz/D1.wav": 3918,
	"./Left/7000Hz/D2.wav": 5305,
	"./Left/7000Hz/D3.wav": 3616,
	"./Left/7000Hz/D4.wav": 3499,
	"./Left/7000Hz/Target.wav": 6032,
	"./Left/8000Hz/D1.wav": 8849,
	"./Left/8000Hz/D2.wav": 4998,
	"./Left/8000Hz/D3.wav": 2511,
	"./Left/8000Hz/D4.wav": 6700,
	"./Left/8000Hz/Target.wav": 6427,
	"./Left/9000Hz/D1.wav": 2748,
	"./Left/9000Hz/D2.wav": 6563,
	"./Left/9000Hz/D3.wav": 2554,
	"./Left/9000Hz/D4.wav": 9169,
	"./Left/9000Hz/Target.wav": 8374,
	"./Right/10000Hz/D1.wav": 1945,
	"./Right/10000Hz/D2.wav": 9790,
	"./Right/10000Hz/D3.wav": 5671,
	"./Right/10000Hz/D4.wav": 9092,
	"./Right/10000Hz/Target.wav": 7443,
	"./Right/1000Hz/D1.wav": 9215,
	"./Right/1000Hz/D2.wav": 1144,
	"./Right/1000Hz/D3.wav": 9553,
	"./Right/1000Hz/D4.wav": 8762,
	"./Right/1000Hz/Target.wav": 7801,
	"./Right/2000Hz/D1.wav": 3348,
	"./Right/2000Hz/D2.wav": 2843,
	"./Right/2000Hz/D3.wav": 7474,
	"./Right/2000Hz/D4.wav": 4649,
	"./Right/2000Hz/Target.wav": 7006,
	"./Right/250Hz/D1.wav": 237,
	"./Right/250Hz/D2.wav": 7426,
	"./Right/250Hz/D3.wav": 5339,
	"./Right/250Hz/D4.wav": 8720,
	"./Right/250Hz/Target.wav": 4991,
	"./Right/3000Hz/D1.wav": 7369,
	"./Right/3000Hz/D2.wav": 5982,
	"./Right/3000Hz/D3.wav": 8455,
	"./Right/3000Hz/D4.wav": 6068,
	"./Right/3000Hz/Target.wav": 7267,
	"./Right/4000Hz/D1.wav": 9390,
	"./Right/4000Hz/D2.wav": 1545,
	"./Right/4000Hz/D3.wav": 8304,
	"./Right/4000Hz/D4.wav": 1627,
	"./Right/4000Hz/Target.wav": 8496,
	"./Right/5000Hz/D1.wav": 5235,
	"./Right/5000Hz/D2.wav": 8892,
	"./Right/5000Hz/D3.wav": 6741,
	"./Right/5000Hz/D4.wav": 278,
	"./Right/5000Hz/Target.wav": 4341,
	"./Right/500Hz/D1.wav": 4381,
	"./Right/500Hz/D2.wav": 5282,
	"./Right/500Hz/D3.wav": 379,
	"./Right/500Hz/D4.wav": 1232,
	"./Right/500Hz/Target.wav": 15,
	"./Right/6000Hz/D1.wav": 2424,
	"./Right/6000Hz/D2.wav": 9727,
	"./Right/6000Hz/D3.wav": 2214,
	"./Right/6000Hz/D4.wav": 1925,
	"./Right/6000Hz/Target.wav": 3162,
	"./Right/7000Hz/D1.wav": 3853,
	"./Right/7000Hz/D2.wav": 130,
	"./Right/7000Hz/D3.wav": 1403,
	"./Right/7000Hz/D4.wav": 5344,
	"./Right/7000Hz/Target.wav": 7615,
	"./Right/8000Hz/D1.wav": 8690,
	"./Right/8000Hz/D2.wav": 1501,
	"./Right/8000Hz/D3.wav": 3668,
	"./Right/8000Hz/D4.wav": 6951,
	"./Right/8000Hz/Target.wav": 76,
	"./Right/9000Hz/D1.wav": 1543,
	"./Right/9000Hz/D2.wav": 4512,
	"./Right/9000Hz/D3.wav": 3609,
	"./Right/9000Hz/D4.wav": 1586,
	"./Right/9000Hz/Target.wav": 7089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4943;